// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.HTMLRenderer {
  white-space: pre-wrap;
  font-size: var(--text-size-normal);
  /* 強調（太字・斜体） */
  /* 箇条書き */
  /* リンク */
}
.HTMLRenderer.loading {
  border-radius: 8px;
}
.HTMLRenderer .text-size-h1 {
  font-weight: bold;
}
.HTMLRenderer .text-size-h2 {
  font-weight: bold;
}
.HTMLRenderer .text-size-h3 {
  font-weight: bold;
}
.HTMLRenderer .bold {
  font-weight: bold;
}
.HTMLRenderer .italic {
  font-style: italic;
  color: #333;
}
.HTMLRenderer ul {
  margin: 10px 0;
  padding-left: 20px;
}
.HTMLRenderer li {
  margin: 5px 0;
  list-style-type: disc;
}
.HTMLRenderer a {
  color: #0078d4;
  text-decoration: none;
  transition: color 0.2s;
}
.HTMLRenderer a:hover {
  color: #0056a3;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/HTMLRenderer.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,qBAAA;EAMA,kCAAA;EAcA,cAAA;EAUA,SAAA;EAWA,QAAA;AAnCJ;AALI;EACI,kBAAA;AAOR;AADI;EACI,iBAAA;AAGR;AAAI;EACI,iBAAA;AAER;AACI;EACI,iBAAA;AACR;AAGI;EACI,iBAAA;AADR;AAII;EACI,kBAAA;EACA,WAAA;AAFR;AAMI;EACI,cAAA;EACA,kBAAA;AAJR;AAOI;EACI,aAAA;EACA,qBAAA;AALR;AASI;EACI,cAAA;EACA,qBAAA;EACA,sBAAA;AAPR;AAUI;EACI,cAAA;EACA,0BAAA;AARR","sourcesContent":[".HTMLRenderer {\r\n    white-space: pre-wrap;\r\n    &.loading{\r\n        border-radius: 8px;\r\n    }\r\n\r\n    \r\n    font-size: var(--text-size-normal);\r\n\r\n    .text-size-h1 {\r\n        font-weight: bold;\r\n    }\r\n\r\n    .text-size-h2 {\r\n        font-weight: bold;\r\n    }\r\n\r\n    .text-size-h3 {\r\n        font-weight: bold;\r\n    }\r\n\r\n    /* 強調（太字・斜体） */\r\n    .bold {\r\n        font-weight: bold;\r\n    }\r\n\r\n    .italic {\r\n        font-style: italic;\r\n        color: #333;\r\n    }\r\n\r\n    /* 箇条書き */\r\n    ul {\r\n        margin: 10px 0;\r\n        padding-left: 20px;\r\n    }\r\n\r\n    li {\r\n        margin: 5px 0;\r\n        list-style-type: disc;\r\n    }\r\n\r\n    /* リンク */\r\n    a {\r\n        color: #0078d4;\r\n        text-decoration: none;\r\n        transition: color 0.2s;\r\n    }\r\n\r\n    a:hover {\r\n        color: #0056a3;\r\n        text-decoration: underline;\r\n    }   \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
